/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import appConfig from "../../api/appConfig";
import cloneDeep from "lodash.clonedeep";
import Popper from "popper.js";
import { mapGetters, mapActions } from "vuex";
import findPath from "../../util/findPath";
import drawPath from "../../util/drawPath";

import Icon from "../common/Icon.vue";
import PlanTip from "../common/PlanTip.vue";

import $ from 'jquery';

const __vue_script__ = {
  name: "FloorPlanWrapper",
  components: {
    Icon,
    PlanTip,
  },
  props: {
    pathFinderData: {
      type: Object,
      default: null,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    floorId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters(["shopById", "currentShop", "currentShopData", "thisKioskData", "content", "shops"]),
    floorName() {
      let text = '';
      if (this.floorId === 0) {
        text = this.content.floor_0;
      } else if (this.floorId === 1) {
        text = this.content.floor_1;
      } else if (this.floorId === 2) {
        text = this.content.floor_2;
      } else if (this.floorId === 3) {
        text = this.content.floor_3;
      } else if (this.floorId === 4) {
        text = this.content.floor_4;
      } else if (this.floorId === 5) {
        text = this.content.floor_5;
      } else if (this.floorId === 6) {
        text = this.content.floor_6;
      } else if (this.floorId === -1) {
        text = this.content.floor_sub1;
      }
      return text;
    },
  },
  watch: {
    currentShop(newId) {
      this.roomMarker(newId);
    },
    pathFinderData(data) {
      if (data) {
        this.pathFinder(data);
      } else {
        if (this.vars.drawnPath) {
          this.vars.drawnPath.clear();
          this.vars.drawnPath = null;
        }
      }
    },
  },
  created() {
    // these vars are not in the data() because, they are not reactive
    this.vars = {
      poppers: [],
      drawnPath: null,
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.pathFinder(this.pathFinderData);
      this.clickHandlers();
      this.roomMarker(this.$store.getters.currentShop);
      this.initPoppers();
      this.showKioskLocation();
      this.hideEmptyRooms();
      this.addStatusClassNames();
    });
  },
  updated() {
    this.initPoppers();
    this.hideEmptyRooms();
    this.addStatusClassNames();
  },
  methods: {
    ...mapActions(["showShopModal"]),
    clickHandlers() {
      const _self = this;
      $(_self.$el)
        .find(".floorPlan_room")
        .on("click", function(e) {
          e.preventDefault();
          const roomId = $(this).attr("id");
          const shop = _self.$store.getters.shopByRoomId(roomId);

          if (shop) {
            _self.$store.dispatch("toggleShop", shop.id);
            _self.$store.dispatch("clearCat");
            _self.$store.dispatch("enableAutoScrollToCurrent");
          }
        });
    },
    roomMarker(shopId) {
      const shop = this.$store.getters.shopById(shopId);
      let rooms = [];
      if (shop && shop.rooms) {
        rooms = this.$store.getters.shopById(shopId).rooms;
      }
      if (rooms.length) {
        this.higlightRooms(rooms);
      } else {
        this.higlightRooms();
      }
    },
    initPoppers() {
      const _self = this;
      _self.destroyPoppers();
      const $poppers = $(_self.$el).find(".js-popper");
      $poppers.each(function(index, element) {
        const roomId = $(element).data("room-id");
        const $reference = $(_self.$el).find("#" + roomId);
        if (!$reference.length) {
          return;
        }
        const offset = $reference.data("offset") || "0, -50%";
        const popperSettings = {
          placement: "top",
          modifiers: {
            offset: {
              offset: offset,
            },
            hide: {
              enabled: false,
            },
            flip: {
              enabled: false,
            },
            preventOverflow: {
              boundariesElement: _self.$el,
            },
            arrow: {
              element: $(element).find(".js-popperArrow")[0],
            },
          },
        };
        $(element).show();
        const popper = new Popper($reference[0], element, popperSettings);
        _self.vars.poppers.push(popper);
      });
    },
    destroyPoppers() {
      this.vars.poppers.map(popper => {
        popper.destroy();
      });
      this.vars.poppers = [];
    },
    showKioskLocation() {
      const _self = this;
      $(_self.$el).find('#' + _self.thisKioskData?.fullId).addClass('st-active');
    },
    hideEmptyRooms() {
      // hide the empty popup store rooms as these are not actual rooms and don't have permanent locations in Viru Keskus.
      const _self = this;
      const popupRooms = []; // 'room_1_51'
      popupRooms.map(roomId => {
        const shop = _self.$store.getters.shopByRoomId(roomId);
        const $room = $(_self.$el).find('#' + roomId);
        if (!shop) {
          $room.hide();
        } else {
          $room.show();
        }
      });

      //$(_self.$el).find('#room_1_51').hide();
    },
    higlightRooms(rooms) {
      const _self = this;
      $(_self.$el)
        .find(".floorPlan_room.st-highlight")
        .removeClass("st-highlight");
      if (rooms && rooms.length) {
        rooms.map(roomId => {
          $(_self.$el)
            .find("#" + roomId)
            .addClass("st-highlight");
        });
      }
    },
    addStatusClassNames() {
      const _self = this;
      const statusClassNames = {
        closed: 'st-closed',
        open: 'st-open',
      };

      for (let i = 0; i < this.shops.length; i++) {
        const shop = this.shops[i];

        if (shop.status === 'open') {
          continue;
        }

        shop.rooms.forEach(roomId => {
          if (!roomId) {
            return;
          }
          $(_self.$el)
            .find("#" + roomId)
            .addClass(statusClassNames[shop.status]);
        })
      }
    },
    pathFinder(data) {
      if (!data) {
        return;
      }

      if (this.floorId !== data.floor) {
        return;
      }

      const _self = this;
      const $waypoints = $(_self.$el).find(".waypoints circle");

      // create waypoints object for this floor
      let thisFloorWaypoints = {};
      $waypoints.each(function() {
        const $this = $(this);
        let waypointData = cloneDeep(appConfig.waypoints[$this.attr("id")]);
        waypointData.connections = waypointData.connectsTo.map(waypointId => {
          const $target = $waypoints.filter("#" + waypointId);
          const a = $this.attr("cx") - $target.attr("cx");
          const b = $this.attr("cy") - $target.attr("cy");
          return {
            id: waypointId,
            distance: Math.sqrt(a * a + b * b),
          };
        });
        waypointData.$collection = $this;
        thisFloorWaypoints[waypointData.id] = waypointData;
      });

      const startingPoint = thisFloorWaypoints[data.startingPoint.id];

      const paths = [];

      data.endPoints.forEach(endPoint => {
        paths.push(findPath({
          startingPoint: cloneDeep(startingPoint) || {},
          endPoint: cloneDeep(thisFloorWaypoints[endPoint.id]) || {},
          nodes: cloneDeep(thisFloorWaypoints),
        }));
      });

      // pick the shortest path
      const shortestPath = paths.sort((a, b) => a.totalDistance - b.totalDistance)[0];

      // clear previous path drawing
      if (_self.vars.drawnPath) {
        _self.vars.drawnPath.clear();
      }

      if (!shortestPath) {
        console.log('Could not find a path to this point');
        return;
      }

      // wait for the fade in animation to finish, otherwise the drawPath function can't get the correct svg element
      window.setTimeout(function() {
        _self.vars.drawnPath = drawPath($(_self.$el).find(".floorPlan_shape").attr('id'), shortestPath.nodes);
      }, 500);

    },
  },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "floorPlan", class: [{ "st-active": _vm.isActive }] },
    [
      _vm.currentShopData
        ? _vm._l(_vm.currentShopData.rooms, function (roomId) {
            return roomId
              ? _c(
                  "div",
                  {
                    key: roomId,
                    staticClass: "floorPlan_tooltip js-popper",
                    staticStyle: { display: "none" },
                    attrs: { "data-room-id": roomId },
                    on: {
                      click: function ($event) {
                        return _vm.showShopModal(_vm.currentShopData.id)
                      },
                    },
                  },
                  [
                    _c("PlanTip", [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.currentShopData.title),
                        },
                      }),
                    ]),
                  ],
                  1
                )
              : _vm._e()
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "floorPlan_info" }, [
        _vm._v(_vm._s(_vm.floorName)),
      ]),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "resources/kiosk/scripts/components/floors/FloorPlanWrapper.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__